export default __webpack_public_path__ + "static/media/bad_eyes.ceba814b.png";